<div class="dl-page dl-page--narrow">
  <app-empty-state icon="block" title="403 — Access denied">
    You do not have permission to use this application. The hub requires the ADMIN
    role; if you believe that is wrong, contact your administrator.
  </app-empty-state>
</div>
